import React from 'react';
import PropTypes from "prop-types";

const NextButton = ({ type = 'button', ...props}) => {
  return (
    <button
      type={type}
      className="form-wizard-action btn btn-primary"
      {...props}
    >
      <i className="fas fa-chevron-circle-right fs-4 me-2"/>
      Next
    </button>
  )
}

NextButton.propTypes  = {
  type: PropTypes.string,
}

export default NextButton